/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorWeekData = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The PerformanceIndicatorWeekData model module.
   * @module model/PerformanceIndicatorWeekData
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorWeekData</code>.
   * @alias module:model/PerformanceIndicatorWeekData
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>PerformanceIndicatorWeekData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorWeekData} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorWeekData} The populated <code>PerformanceIndicatorWeekData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('SelectedYear')) {
        obj['SelectedYear'] = ApiClient.convertToType(data['SelectedYear'], 'Integer');
      }
      if (data.hasOwnProperty('SelectedWeek')) {
        obj['SelectedWeek'] = ApiClient.convertToType(data['SelectedWeek'], 'Integer');
      }
      if (data.hasOwnProperty('KeyPerformanceIndicatorID')) {
        obj['KeyPerformanceIndicatorID'] = ApiClient.convertToType(data['KeyPerformanceIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Date')) {
        obj['Date'] = ApiClient.convertToType(data['Date'], 'Date');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('Actual')) {
        obj['Actual'] = ApiClient.convertToType(data['Actual'], 'Number');
      }
      if (data.hasOwnProperty('ActualSourceID')) {
        obj['ActualSourceID'] = ApiClient.convertToType(data['ActualSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('LastActualUpdate')) {
        obj['LastActualUpdate'] = ApiClient.convertToType(data['LastActualUpdate'], 'Date');
      }
      if (data.hasOwnProperty('Budget')) {
        obj['Budget'] = ApiClient.convertToType(data['Budget'], 'Number');
      }
      if (data.hasOwnProperty('BudgetSourceID')) {
        obj['BudgetSourceID'] = ApiClient.convertToType(data['BudgetSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('Forecast')) {
        obj['Forecast'] = ApiClient.convertToType(data['Forecast'], 'Number');
      }
      if (data.hasOwnProperty('ForecastSourceID')) {
        obj['ForecastSourceID'] = ApiClient.convertToType(data['ForecastSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('Goal')) {
        obj['Goal'] = ApiClient.convertToType(data['Goal'], 'Number');
      }
      if (data.hasOwnProperty('GoalSourceID')) {
        obj['GoalSourceID'] = ApiClient.convertToType(data['GoalSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('Comment')) {
        obj['Comment'] = ApiClient.convertToType(data['Comment'], 'String');
      }
      if (data.hasOwnProperty('BudgetFileID')) {
        obj['BudgetFileID'] = ApiClient.convertToType(data['BudgetFileID'], 'Integer');
      }
      if (data.hasOwnProperty('BudgetEntryID')) {
        obj['BudgetEntryID'] = ApiClient.convertToType(data['BudgetEntryID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastFileID')) {
        obj['ForecastFileID'] = ApiClient.convertToType(data['ForecastFileID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastEntryID')) {
        obj['ForecastEntryID'] = ApiClient.convertToType(data['ForecastEntryID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PeriodTypeID
   * @default 0
   */
  exports.prototype['PeriodTypeID'] = 0;
  /**
   * @member {Integer} SelectedYear
   * @default 0
   */
  exports.prototype['SelectedYear'] = 0;
  /**
   * @member {Integer} SelectedWeek
   * @default 0
   */
  exports.prototype['SelectedWeek'] = 0;
  /**
   * @member {Integer} KeyPerformanceIndicatorID
   * @default 0
   */
  exports.prototype['KeyPerformanceIndicatorID'] = 0;
  /**
   * @member {Date} Date
   */
  exports.prototype['Date'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Number} Actual
   * @default 0.0
   */
  exports.prototype['Actual'] = 0.0;
  /**
   * @member {Integer} ActualSourceID
   */
  exports.prototype['ActualSourceID'] = undefined;
  /**
   * @member {Date} LastActualUpdate
   */
  exports.prototype['LastActualUpdate'] = undefined;
  /**
   * @member {Number} Budget
   * @default 0.0
   */
  exports.prototype['Budget'] = 0.0;
  /**
   * @member {Integer} BudgetSourceID
   */
  exports.prototype['BudgetSourceID'] = undefined;
  /**
   * @member {Number} Forecast
   * @default 0.0
   */
  exports.prototype['Forecast'] = 0.0;
  /**
   * @member {Integer} ForecastSourceID
   */
  exports.prototype['ForecastSourceID'] = undefined;
  /**
   * @member {Number} Goal
   * @default 0.0
   */
  exports.prototype['Goal'] = 0.0;
  /**
   * @member {Integer} GoalSourceID
   */
  exports.prototype['GoalSourceID'] = undefined;
  /**
   * @member {String} Comment
   * @default ''
   */
  exports.prototype['Comment'] = '';
  /**
   * @member {Integer} BudgetFileID
   */
  exports.prototype['BudgetFileID'] = undefined;
  /**
   * @member {Integer} BudgetEntryID
   */
  exports.prototype['BudgetEntryID'] = undefined;
  /**
   * @member {Integer} ForecastFileID
   */
  exports.prototype['ForecastFileID'] = undefined;
  /**
   * @member {Integer} ForecastEntryID
   */
  exports.prototype['ForecastEntryID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


